<section class="bg-white p-4">
  <div class="row mb-3">
    <div class="col-lg-12">
      <button class="pull-right btn btn-primary" (click)="addPhoto()" [hidden]="!pageAccess?.c">
        <i class="fa fa-plus mr-2" aria-hidden="true"></i>Add Photo
      </button>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-lg-12">
      <div class="photo-upload-title">Youth Photos</div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-xl-12">
      <div class="row" *ngIf="youthPhotoList.length; else noYouthPhoto" >
        <div class="col-lg-4 mb-4 d-flex align-items-stretch" *ngFor="let item of youthPhotoListDefault">
          <div class="card viewPhoto">
            <div class="viewPhotoInner">
              <div class="photo-action">
                <a href="javascript:;" (click)="showPreviewPhoto(item)"><i class="fa fa-search-plus" aria-hidden="true"></i></a>
                <a href="javascript:;" (click)="closePopup(item)"
                [ngClass]="{'disabled-link': !pageAccess?.d}"
                [style.pointer-events]="!pageAccess?.d ? 'none' : 'auto'"
                [attr.aria-hide]="!pageAccess?.d ? 'true' : null">
                <i class="fa fa-trash-o" *ngIf="item.isOwner && item.isDeletable" aria-hidden="true"></i></a>
                <a href="javascript:;" (click)="showPrimayIcon(item)"
                  [ngClass]="{'disabled-link': !pageAccess?.u}"
                  [style.pointer-events]="!pageAccess?.u ? 'none' : 'auto'"
                  [attr.aria-hide]="!pageAccess?.u ? 'true' : null">
                  <i [ngClass]="item.primary_flag ? 'fa fa-star-o active' : 'fa fa-star-o'" aria-hidden="true" [hidden]="!pageAccess?.u"></i></a>
              </div>
              <img [src]="item.url_pic" class="card-img-top" alt="Youth Photo">
              <div class="set-primary" [hidden]="!item.primary_flag">
                <i class="fa fa-star-o" aria-hidden="true"  [hidden]="!pageAccess?.u"></i>
                Primary
              </div>
            </div>
            <div class="card-body">
              <dl>
                <dt>Photo Date:</dt>
                <dd>{{item.photo_date | date: 'MM/dd/yyyy'}}</dd>
              </dl>
              <dl>
                <dt>Description:</dt>
                <dd>{{item.description}}</dd>
              </dl>
              <dl>
                <dt>Entered By:</dt>
                <dd>{{item.lastname}},&nbsp;{{item.firstname}}
                  <span *ngIf="item.middlename">{{item.middlename}}</span></dd>
              </dl>
              <dl>
                <dt>Entered Date:</dt>
                <dd>{{item.entered_date | date: 'MM/dd/yyyy'}}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noYouthPhoto>
        <p class="no-data-found" >No Data</p>
      </ng-template>
    </div>
  </div>
  <div class="row mt-4 mb-3">
    <div class="col-lg-12">
      <div class="photo-upload-title">SCAR, MARK, OR TATTOO</div>
    </div>
  </div>
  <div class="row" *ngIf="scarPhotoList.length; else noScarData">
    <div class="col-lg-12 col-xl-12">
      <div class="row">
        <div class="col-lg-4 mb-4 d-flex align-items-stretch"  *ngFor="let item of scarPhotoListDefault">
          <div class="card viewPhoto">
            <div class="viewPhotoInner">
              <div class="photo-action">
                <a href="javascript:;" (click)="showPreviewPhoto(item)"><i class="fa fa-search-plus" aria-hidden="true"></i></a>
                <a href="javascript:;" (click)="closePopup(item)" [disabled]="!pageAccess?.d"><i class="fa fa-trash-o" *ngIf="item.isOwner && item.isDeletable" aria-hidden="true"></i></a>
              </div>
              <img [src]="item.url_pic" class="card-img-top" alt="Scar Photo">
            </div>
            <div class="card-body">
              <dl>
                <dt>Photo Date:</dt>
                <dd>{{item.photo_date | date: 'MM/dd/yyyy'}}</dd>
              </dl>
              <dl>
                <dt>Description:</dt>
                <dd>{{item.description}}</dd>
              </dl>
              <dl>
                <dt>Entered By:</dt>
                <dd>{{item.lastname}},&nbsp;{{item.firstname}}
                  <span *ngIf="item.middlename">{{item.middlename}}</span>
                  </dd>
              </dl>
              <dl>
                <dt>Entered Date:</dt>
                <dd>{{item.entered_date | date: 'MM/dd/yyyy'}}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noScarData >
    <p class="no-data-found" >No Data</p>
  </ng-template>
</section>

<!-- Modal -->
<div class="modal fade popupnew" id="deletephoto" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="deletephoto" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <p *ngIf="!primaryFlag">Are you sure you want to remove this photo?</p>
        <p *ngIf="primaryFlag">You are deleting the only photo. Are you sure you want to remove this Youth Photo?</p>
        <!-- <span>This cannot be undone</span> -->
        <div class="clearfix mt-2">
          <button class="pull-right btn btn-primary btncommon delete" (click)="deletePhoto()">
            Yes
          </button>
          <button data-dismiss="modal" class="pull-right mr-2 btn bg-white text-primary btncancel">No</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Photo Preview-->
<div class="modal fade popupnew" id="photoPreview" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="deletephoto" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body text-center">
          <h5>Youth Image</h5>
          <a class="close" data-dismiss="modal" aria-label="Close">&times;</a>
          <img [src]="imageUrl" class="img-fluid previewPhoto" alt="Youth Photo" />
      </div>
    </div>
  </div>
</div>
